import { render } from "./CommentsList.vue?vue&type=template&id=10b6a639&scoped=true"
import script from "./CommentsList.vue?vue&type=script&lang=js"
export * from "./CommentsList.vue?vue&type=script&lang=js"

import "./CommentsList.vue?vue&type=style&index=0&id=10b6a639&lang=scss&scoped=true"

import exportComponent from "/Users/luke/Documents/contility/server/src/views/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10b6a639"]])

export default __exports__